import React from 'react';
import styles from './TagsInformation.module.scss';
import { InitiativeTags } from '../../../../../../../../Models/InitiativeValue';
import { SFChip } from 'sfui';

export interface TagsInformationProps {
  tags: InitiativeTags;
}

export const TagsInformation = ({
  tags
}: TagsInformationProps): React.ReactElement<TagsInformationProps> => {
  return (
    <div className={styles.tagsInformation}>
      <div className={styles.chips}>
        {tags.agency.map((t) => (
          <SFChip
            key={t.id}
            size="small"
            variant="outlined"
            sfColor={t.color}
            label={t.name}
          />
        ))}
      </div>
    </div>
  );
};
